"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _HotelDetails = _interopRequireDefault(require("./HotelDetails.proptypes"));

var _constant = require("../FlightDetails/constant");

var DefaultHotelDetailsWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelDetails__DefaultHotelDetailsWrapper",
  componentId: "sc-121apnk-0"
})([""]);

var HotelInfoBody = _styledComponents.default.div.withConfig({
  displayName: "HotelDetails__HotelInfoBody",
  componentId: "sc-121apnk-1"
})(["font-size:", ";display:flex;align-items:center;"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSize.normal;
});

HotelInfoBody.displayName = 'HotelInfoBody';
var NewHotelIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "HotelDetails__NewHotelIcon",
  componentId: "sc-121apnk-2"
})(["& path{transform:scale(1.5);}"]);

var HotelLogoContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelDetails__HotelLogoContainer",
  componentId: "sc-121apnk-3"
})(["min-width:", ";display:flex;align-items:center;justify-content:flex-start;padding:", ";margin-right:-5px;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.standard;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.space.XXXSmall, " 0 0 0");
});

HotelLogoContainer.displayName = 'HotelLogoContainer';

var HotelNameContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelDetails__HotelNameContainer",
  componentId: "sc-121apnk-4"
})(["color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:", ";display:flex;align-items:center;flex-wrap:wrap;margin-left:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.neutral;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontFamily.default;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeight.medium;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.small;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.lineHeight.normal;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.lineHeight.XSmall;
});

HotelNameContainer.displayName = 'HotelNameContainer';

var HotelBookingInfoBody = _styledComponents.default.div.withConfig({
  displayName: "HotelDetails__HotelBookingInfoBody",
  componentId: "sc-121apnk-5"
})(["display:flex;align-items:center;justify-content:flex-start;margin-left:15px;"]);

HotelBookingInfoBody.displayName = 'HotelBookingInfoBody';

var HotelBookingInfoContainer = _styledComponents.default.span.withConfig({
  displayName: "HotelDetails__HotelBookingInfoContainer",
  componentId: "sc-121apnk-6"
})(["color:", ";font-size:", ";font-family:", ";font-weight:", ";font-weight:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.greyDark;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSize.XSmall;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontFamily.default;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontWeight.normal;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontWeight.normal;
});

HotelBookingInfoContainer.displayName = 'HotelBookingInfoContainer';

var HotelDetails = function HotelDetails(props) {
  var accessible = props.accessible,
      theme = props.theme,
      data = props.data;

  var HotelIcon = /*#__PURE__*/_react.default.createElement(NewHotelIcon, {
    accessible: true,
    color: _constant.ICON_TYPE.normal.color,
    customProperties: {
      id: 'icon-id'
    },
    fontsize: "titleSmall",
    icon: "NewHotelIcon",
    theme: theme
  });

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(DefaultHotelDetailsWrapper, {
    tabIndex: !accessible ? '-1' : '0'
  }, /*#__PURE__*/_react.default.createElement(HotelInfoBody, null, /*#__PURE__*/_react.default.createElement(HotelLogoContainer, null, HotelIcon), /*#__PURE__*/_react.default.createElement(HotelNameContainer, null, data.name)), /*#__PURE__*/_react.default.createElement(HotelBookingInfoBody, null, /*#__PURE__*/_react.default.createElement(HotelLogoContainer, null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(HotelBookingInfoContainer, null, data.checkInDate, " - ", data.checkOutDate), /*#__PURE__*/_react.default.createElement(HotelBookingInfoContainer, null, " | "), /*#__PURE__*/_react.default.createElement(HotelBookingInfoContainer, null, data.roomDetails, ", ", data.nights, " nights")))));
};

HotelDetails.propTypes = _HotelDetails.default.PropTypes;
HotelDetails.defaultProps = _HotelDetails.default.DefaultProps;
var _default = HotelDetails;
exports.default = _default;